<div class="container-wrapper">
  <div class="container">
    <div class="cover" [class.flip]="showSignup">
      <div class="front">
        <img src="assets/images/auth/frontImg.jpg" alt="Front" />
        <div class="text">
          <span class="text-1">Welcome to PraticaOne</span>
          <span class="text-2">Manage your legal cases easily with e-Court integration and grow your business with our powerful legal software.</span>
        </div>
      </div>
      <div class="back">
        <img src="assets/images/auth/backImg.jpg" alt="Back" />
        <div class="text">
          <span class="text-1">Complete miles of journey <br> with one step</span>
          <span class="text-2">Let's get started</span>
        </div>
      </div>
    </div>
  
    <div class="forms">
      <div class="form-content">
        <!-- Login Form -->
        <div class="login-form" >
          <div class="title">Login</div>
          <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
            <div class="input-boxes">
              <div class="input-box">
                <i class="fa fa-envelope"></i>
                <input type="email" placeholder="Enter your email" formControlName="email" />
              </div>
              <div class="text-danger small" *ngIf="loginForm.get('email').invalid && loginForm.get('email').touched">
                Valid email is required
              </div>
  
              <div class="input-box">
                <i class="fa fa-lock"></i>
                <input [type]=" showPassword ? 'text' : 'password'" name="password" id="password" placeholder="Enter your password" formControlName="password" />
                <i class="password-toggle" [ngClass]=" showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" (click)="togglePasswordVisibility()"></i>
              </div>
              <div class="text-danger small" *ngIf="loginForm.get('password').invalid && loginForm.get('password').touched">
                Password is required
              </div>

              <div class="text d-flex align-items-center mt-2">
                <input type="checkbox" class="mt-0" style="cursor: pointer;" formControlName="acceptTerms" /> 
                <a
                  class="ml-2 "
                  target="_blank"
                  href="https://redleafsoftwares.com/welcome/privacy_policy"
                  >I Agree to the terms</a
                >
                <!-- <div class="ml-auto"></div> -->
                <a class="ml-auto"  style="color: #005da0 !important" href="javascript:void(0)" (click)="toggleForm()" >Forgot password?</a></div>
  
              <div class="button input-box">
                <input type="submit" value="Submit" />
              </div>

                <div class="text-center mt-4 medium">
                <div class="copyright-text" >© 2024-25 PraticaOne</div>
                Powered & Maintained By:
                <div>
                  <a
                    href="https://redleafsoftwares.com"
                    target="_blank"
                    style="color: #005da0 !important"
                  >
                    RedLeaf Softwares & Services LLP
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
  
        <!-- Signup Form -->
        <div class="signup-form" *ngIf="showSignup">
          <div class="title">Recover Password</div>
          <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordSubmit()">
            <div class="input-boxes">
              <!-- <div class="input-box">
                <i class="fa fa-user input-icon"></i>
                <input type="text" placeholder="Enter code" formControlName="code" />
              </div>
              <div class="text-danger small" *ngIf="forgotPasswordForm.get('code').invalid && forgotPasswordForm.get('code').touched">
                Code is required
              </div>

              <div class="input-box">
                <i class="fa fa-user input-icon"></i>
                <input type="text" placeholder="Enter user name" formControlName="userName" />
              </div>
              <div class="text-danger small" *ngIf="forgotPasswordForm.get('userName').invalid && forgotPasswordForm.get('userName').touched">
                User name is required
              </div>

              <p class="text-center break-line">OR</p> -->
  
              <div class="input-box">
                <i class="fa fa-envelope"></i>
                <input type="email" placeholder="Enter registered email" formControlName="email" />
              </div>
              <div class="text-danger small" *ngIf="forgotPasswordForm.get('email').invalid && forgotPasswordForm.get('email').touched">
                Valid email is required
              </div>
  
              <div class="button input-box">
                <input type="submit" value="Submit" />
              </div>

              <div *ngIf="showMsg" [ngClass]="status == 200 ? 'text-success' : 'text-danger'" class="text-center large mt-2 text-break"  >
                {{ Msg }}
              </div>
              <div class="text sign-up-text">
                <a href="javascript:void(0)"  style="color: #005da0 !important" (click)="toggleForm()">Go to Login</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
